import type { TokenStore } from '@fluxter/shared';

const KEY = 'fluxter.auth.token';

export const localStorageTokenStore = (): TokenStore => ({
  get: () => (typeof window === 'undefined' ? null : window.localStorage.getItem(KEY)),
  set: (token) => window.localStorage.setItem(KEY, token),
  clear: () => window.localStorage.removeItem(KEY),
});
